import React, { useEffect } from 'react'
import './Privacy_Policy.css'
import Breadcrumb_comp from '../common-components/breadcrumb-comp/Breadcrumb_comp';
import Green_Outline_Btn from '../common-components/common_btn/green_outline_btn/Green_Outline_Btn';
import Light_Gray_Outline_Btn from '../common-components/common_btn/gray_outline_btn/Light_Gray_Outline_Btn';
import Stay_Connected from '../home/stay_Connected/Stay_Connected';
import { useDispatch, useSelector } from 'react-redux';
import { getPrivacy_Policy } from '../../features/privacypolicy/Slice';
import parse from "html-react-parser"

const Privacy_Policy = () => {

    const breadcrumbs = [
        { label: "Home", link: "/", isActive: false },
        { label: "PRIVACY POLICY", link: "", isActive: true },
    ];

    const privacyPolicy = useSelector((state) => state.privacypolicy.privacypolicy)
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getPrivacy_Policy());

    },[])

    return (
        <>
            <section className='Privacy_Policy'>
                <div className='bg_img_div'>
                    {/* <div className='bg_div'>
                        <img src='/assets/images/privacy/bg2.png' className='bg_img' />
                    </div> */}
                    <div className='white_bg_div'>
                        <Breadcrumb_comp breadcrumbs={breadcrumbs} />
                        <div className='container'>
                            <p className='section_title'>Privacy Policy</p>
                        </div>
                    </div>
                </div>
                <div className='container'>
                    <div className='main_content_div'>
                        {privacyPolicy?.map((pp) => (<p className='dark_black_text'>{parse(pp.content)}</p>))}
                        {/* <div className='btns_holder'>
                            <Light_Gray_Outline_Btn btnText={"Decline"} />
                            <Green_Outline_Btn btnText={"Accept"} />
                        </div> */}
                    </div>
                </div>
            </section>
            {/* <Stay_Connected /> */}
        </>

    )
}

export default Privacy_Policy
